<template>
	<div>
		<div class="loader" v-if="loading">
			<div class="background">
				<div id="text">
					<p class="h2">
						Loading...
					</p>
				</div>
			</div>
		</div>
		<div class="modal fade" id="tutorEditModal" tabindex="-1">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<div class="wizard-steps-container">
							<div
								v-bind:class="
									activeStep === 1
										? 'step active'
										: activeStep >= 1
										? 'step passed'
										: 'step'
								"
							>
								1
							</div>
							<div
								v-bind:class="
									activeStep >= 2 ? 'seperator active' : 'seperator'
								"
							></div>
							<div
								v-bind:class="
									activeStep === 2
										? 'step active'
										: activeStep >= 2
										? 'step passed'
										: 'step'
								"
							>
								2
							</div>
							<div
								v-bind:class="
									activeStep >= 3 ? 'seperator active' : 'seperator'
								"
							></div>
							<div
								v-bind:class="
									activeStep === 3
										? 'step active'
										: activeStep >= 3
										? 'step passed'
										: 'step'
								"
							>
								3
							</div>
							<div
								v-bind:class="
									activeStgep === 4 ? 'seperator active' : 'seperator'
								"
							></div>
							<div v-bind:class="activeStep >= 4 ? 'step active' : 'step'">
								4
							</div>
						</div>
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
							v-on:click="closeTutor"
						></button>
					</div>
					<div class="modal-body">
						<div v-if="activeStep === 1" class="step-body step-1">
							<h2 class="step-title">{{ $t("basicInfo") }}</h2>
							<div class="avatar-container">
								<div
									class="avatar-image"
									v-bind:style="`background-image: url('${currentAvatar}')`"
								></div>
								<input
									type="file"
									id="photoInput"
									hidden
									accept="image/png, image/jpeg"
									v-on:change="changeCurrentAvatar"
								/>
								<button
									class="btn-secondary upload-btn"
									v-on:click="uploadPhoto"
								>
									{{ $t("uploadPhoto") }}
								</button>
							</div>
							<div class="row data-container">
								<div class="col-md-6">
									<div class="mb-3 input-container">
										<label for="firstNameInput" class="form-label">{{
											$t("first_name")
										}}</label>
										<input
											type="text"
											class="form-control"
											id="firstNameInput"
											v-model="localTutor.first_name"
										/>
									</div>
									<div class="mb-3 input-container">
										<label for="lastNameInput" class="form-label">{{
											$t("last_name")
										}}</label>
										<input
											type="text"
											class="form-control"
											id="lastNameInput"
											v-model="localTutor.last_name"
										/>
									</div>
									<div class="mb-3 input-container">
										<label for="emailInput" class="form-label">{{
											$t("Email")
										}}</label>
										<input
											disabled
											type="email"
											class="form-control"
											id="emailInput"
											v-model="localTutor.email"
										/>
									</div>
									<div class="mb-3 input-container">
										<label for="mobileInput" class="form-label">{{
											$t("phone_number")
										}}</label>
										<input
											type="text"
											class="form-control"
											id="mobileInput"
											v-model="localTutor.phone_number"
										/>
									</div>
									<div class="mb-3 input-container">
										<label for="dopInput" class="form-label">{{
											$t("birthdate")
										}}</label>
										<input
											type="date"
											class="form-control"
											id="dopInput"
											v-model="localTutor.date_of_birth"
										/>
									</div>
									<div class="mb-3 input-container">
										<label for="countryInput" class="form-label">{{
											$t("country")
										}}</label>
										<select
											class="form-select form-control"
											aria-label="Default select example"
											id="countryInput"
											v-model="localTutor.country_id"
										>
											<option v-bind:value="undefined">{{
												$t("selectCountry")
											}}</option>
											<option
												v-for="country in countries"
												:key="country.id"
												v-bind:value="country.id"
											>
												{{ country.name }}
											</option>
										</select>
									</div>
									<div class="mb-3 input-container">
										<label class="form-label">{{ $t("language") }}</label>
										<select class="form-select form-control" v-model="currLang">
											<option selected disabled value="">
												{{ $t("selectLanguage") }}
											</option>
											<option v-for="lang of languages" :key="lang.native_name">
												{{ lang.name }}
											</option>
										</select>
									</div>
									<div class="mb-3 input-container">
										<label class="form-label">{{ $t("level") }}</label>
										<select
											class="form-select form-control"
											v-model="currLevel"
											@change="addLanguage"
											:disabled="!currLang"
										>
											<option selected disabled value="">{{
												$t("selectLevel")
											}}</option>
											<option v-for="level of levels" :key="level.id">
												{{ level }}
											</option>
										</select>
									</div>
									<div>
										<!-- <div
                            class="d-flex justify-content-end align-items-center mb-3"
                          >
                            <button class="btn btn-primary" @click="addLanguage">
                              <i class="fa-solid fa-plus"></i> Add Language
                            </button>
                          </div> -->
										<v-chip
											closable
											@click="clearLang(language.id)"
											v-for="language of choosedLanguages"
											:key="language.id"
											class="me-2 mb-2"
										>
											{{ language.details.language }} -
											{{ language.details.level }}
										</v-chip>
									</div>
								</div>
								<div class="col-md-6">
									<div class="mb-3 input-container">
										<label for="feeInput" class="form-label">{{
											$t("feesPerSession")
										}}</label>
										<input
											type="number"
											class="form-control"
											id="feeInput"
											v-model="localTutor.session_fee"
										/>
									</div>
									<div class="mb-3 input-container textarea">
										<label for="bioInput" class="form-label"
											>{{ $t("bio/certificates") }}
										</label>
										<textarea
											class="form-control"
											id="bioInput"
											rows="3"
											v-model="localTutor.bio"
										></textarea>
									</div>
								</div>
							</div>
						</div>
						<div v-if="activeStep === 2" class="step-body step-2">
							<h2 class="step-title">{{ $t("courses") }}</h2>
							<div class="row data-container">
								<div
									class="col course-container"
									v-for="(courseType, index) in localTutor.courses"
									v-bind:key="index"
								>
									<p class="course-title">{{ index }}:</p>
									<div class="form-check">
										<input
											v-bind:class="`form-check-input course-checkbox-${index}`"
											type="checkbox"
											v-bind:id="`${courseType}Enabled`"
											v-on:change="toggleSelectAll(index)"
										/>
										<label
											class="form-check-label"
											v-bind:for="`${courseType}Enabled`"
										>
											{{ $t("selectAll") }}
										</label>
									</div>
									<hr />
									<div class="courses-container">
										<div
											class="form-check"
											v-for="(course, index) in courseType"
											v-bind:key="index"
										>
											<input
												class="form-check-input"
												type="checkbox"
												v-bind:id="`${course.id}Enabled`"
												v-on:click="toggleCourseAssociate(course)"
												v-bind:checked="
													localTutor.associatedCourses[
														course.course_type_name
													] &&
														localTutor.associatedCourses[
															course.course_type_name
														].includes(course.id)
												"
											/>
											<label
												class="form-check-label"
												v-on:click="toggleCourseAssociate(course)"
											>
												{{ course.title }}
											</label>
											<div
												v-on:click="startCourseFileUpload(course.id)"
												class="file-upload-icon-button"
												title="Upload Course file"
												v-if="
													localTutor.associatedCourses[
														course.course_type_name
													] &&
														localTutor.associatedCourses[
															course.course_type_name
														].includes(course.id)
												"
											>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="16"
													height="16"
													fill="currentColor"
													class="bi bi-cloud-arrow-up-fill"
													viewBox="0 0 16 16"
												>
													<path
														d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2z"
													/>
												</svg>
											</div>
										</div>
									</div>

									<!-- <div v-bind:class="course.enabled?`input-container file-input mb-3`:`input-container file-input mb-3 disabled`" 
                                v-on:click="chooseFile(course)">
                                  
                                  <label for="fileInput" class="form-label">Upload <br>video/Audio:</label>
                                  <div class="input-group my-auto w-100">
                                      <span class="input-group-text">Choose File</span>
                                      <input type="file" v-bind:id="`fileInput${course.id}`" hidden accept="video/* , audio/*"
                                      v-on:change="changeCurrentCourseFile($event,course)"/>
                                      <input type="text" class="form-control" id="fileInput" placeholder="No file chosen" 
                                      v-model="course.tempFile.name" disabled>
                                  </div>
                                </div>
                                <button v-on:click="appendTempFile(course)" v-bind:disabled="!course.enabled || !course.tempFile.file">Add Video/Audio</button>
                                <div v-if="course.enabled" class="files-container">
                                  <div class="single-file" v-for="(file, index) in course.files">
                                      <span>{{file.name}}</span>
                                      <svg v-on:click="removeFile(course,index)" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                                      </svg>
                                  </div>
                                </div> -->
								</div>
							</div>
						</div>
						<div v-if="activeStep === 3" class="step-body step-3">
							<h2 class="step-title">{{ $t("mySchedule") }}</h2>
							<div class="row data-container">
								<div class="col-md-8 overflow-y-auto days-container">
									<!-- <div class="accordion" id="accordionExample">
                                  <div class="accordion-item" v-for="(day,index) in schedule" v-bind:key="index">
                                    <h2 class="accordion-header" v-bind:id="`heading${index}`">
                                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" 
                                      v-bind:data-bs-target="`#collapse${index}`" aria-expanded="true" 
                                      v-bind:aria-controls="`collapse${index}`">
                                        {{day.date}}
                                      </button>
                                    </h2>
                                    <div v-bind:id="`collapse${index}`" class="accordion-collapse collapse" 
                                    v-bind:aria-labelledby="`heading${index}`" data-bs-parent="#accordionExample">
                                      <div class="accordion-body">
                                        <div class="slot-card" v-for="(slot,index2) in day.slots" v-bind:key="index2"
                                        v-on:click="currentSlot = slot">
                                          <div>{{slot.start_datetime.format('hh:mm a')}}</div>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                          </svg>
                                          <div>{{slot.end_datetime.format('hh:mm a')}}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div> -->
									<calendar
										v-bind:events="events"
										v-on:event-selected="changeCurrentSlot"
									></calendar>
								</div>
								<div class="col-md-4">
									<div
										v-if="!showAddSlot && currentSlot"
										class="current-slot-card"
									>
										<div class="delete-icon" v-on:click="deleteSlot">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="16"
												height="16"
												fill="currentColor"
												class="bi bi-trash"
												viewBox="0 0 16 16"
											>
												<path
													d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
												/>
												<path
													fill-rule="evenodd"
													d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
												/>
											</svg>
										</div>

										<h3>{{ $t("selectedSlots") }}</h3>

										<div class="row">
											<div class="col-md-6">
												<div class="input-container mb-3">
													<label for="startTimeInput" class="form-label"
														>{{ $t("fromDate") }}:</label
													>
													<div class="input-group my-auto">
														<span class="input-group-text">{{
															currentSlot.start_datetime.format("A")
														}}</span>
														<input
															type="text"
															class="form-control"
															id="startTimeInput"
															placeholder="00.0"
															disabled
															v-bind:value="
																currentSlot.start_datetime.format('hh:mm')
															"
														/>
													</div>
												</div>
											</div>
											<div class="col-md-6">
												<div class="input-container mb-3">
													<label for="endTimeInput" class="form-label"
														>{{ $t("toDate") }}:</label
													>
													<div class="input-group my-auto">
														<span class="input-group-text">{{
															currentSlot.end_datetime.format("A")
														}}</span>
														<input
															type="text"
															class="form-control"
															id="endTimeInput"
															placeholder="00.0"
															disabled
															v-bind:value="
																currentSlot.end_datetime.format('hh:mm')
															"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<button
										v-if="!showAddSlot"
										type="button"
										class="btn btn-secondary"
										v-on:click="startAddSlot"
									>
										{{ $t("addNewSlot") }}
									</button>
									<div v-if="showAddSlot" class="current-slot-card">
										<div class="delete-icon" v-on:click="cancelAddSlot">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="16"
												height="16"
												fill="currentColor"
												class="bi bi-x-lg"
												viewBox="0 0 16 16"
											>
												<path
													d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
												/>
											</svg>
										</div>

										<h3>Slot Data</h3>

										<div class="row">
											<div class="col-md-6">
												<v-dialog
													ref="dialog"
													v-model="modal"
													v-bind:return-value.sync="newSlot.start_date"
													persistent
													width="290px"
												>
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
															v-model="newSlot.start_date"
															label="Start date"
															prepend-icon="mdi-calendar"
															v-bind="attrs"
															v-on="on"
														></v-text-field>
													</template>
													<v-date-picker
														v-model="newSlot.start_date"
														show-current
														v-bind:min="new Date().toISOString()"
													>
														<v-spacer></v-spacer>
														<v-btn
															text
															color="primary"
															v-on:click="modal = false"
														>
															{{ $t("Cancel") }}
														</v-btn>
														<v-btn
															text
															color="primary"
															v-on:click="$refs.dialog.save(newSlot.start_date)"
														>
															{{ $t("ok") }}</v-btn
														>
													</v-date-picker>
												</v-dialog>
											</div>
											<div class="col-md-6">
												<v-dialog
													ref="endDateDialog"
													v-model="endDateModal"
													v-bind:return-value.sync="newSlot.end_date"
													persistent
													width="290px"
												>
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
															v-model="newSlot.end_date"
															label="End date"
															prepend-icon="mdi-calendar"
															v-bind="attrs"
															v-on="on"
														></v-text-field>
													</template>
													<v-date-picker
														v-model="newSlot.end_date"
														show-current
														v-bind:min="
															newSlot.start_date || new Date().toISOString()
														"
													>
														<v-spacer></v-spacer>
														<v-btn
															text
															color="primary"
															v-on:click="endDateModal = false"
														>
															{{ $t("Cancel") }}
														</v-btn>
														<v-btn
															text
															color="primary"
															v-on:click="
																$refs.endDateDialog.save(newSlot.end_date)
															"
														>
															{{ $t("ok") }}
														</v-btn>
													</v-date-picker>
												</v-dialog>
											</div>
										</div>
										<div class="row">
											<div class="col-md-6">
												<v-dialog
													ref="startTimeDialog"
													v-model="startTimeModal"
													v-bind:return-value.sync="newSlot.start_time"
													presistent
													width="290px"
												>
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
															v-model="newSlot.start_time"
															label="Start time"
															prepend-icon="mdi-clock-time-four-outline"
															v-bind="attrs"
															v-on="on"
														></v-text-field>
													</template>
													<v-time-picker
														v-model="newSlot.start_time"
														full-width
													>
														<v-spacer></v-spacer>
														<v-btn
															text
															color="primary"
															v-on:click="startTimeModal = false"
														>
															{{ $t("Cancel") }}
														</v-btn>
														<v-btn
															text
															color="primary"
															v-on:click="
																$refs.startTimeDialog.save(newSlot.start_time)
															"
														>
															{{ $t("ok") }}
														</v-btn>
													</v-time-picker>
												</v-dialog>
											</div>
											<div class="col-md-6">
												<v-dialog
													ref="endTimeDialog"
													v-model="endTimeModal"
													v-bind:return-value.sync="newSlot.end_time"
													presistent
													width="290px"
												>
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
															v-model="newSlot.end_time"
															label="End time"
															prepend-icon="mdi-clock-time-four-outline"
															v-bind="attrs"
															v-on="on"
														></v-text-field>
													</template>
													<v-time-picker
														v-model="newSlot.end_time"
														full-width
														v-bind:min="newSlot.start_time"
													>
														<v-spacer></v-spacer>
														<v-btn
															text
															color="primary"
															v-on:click="endTimeModal = false"
														>
															{{ $t("Cancel") }}
														</v-btn>
														<v-btn
															text
															color="primary"
															v-on:click="
																$refs.endTimeDialog.save(newSlot.end_time)
															"
														>
															{{ $t("ok") }}
														</v-btn>
													</v-time-picker>
												</v-dialog>
											</div>
										</div>

										<div class="row">
											<div class="col-md-12">
												<div class="input-container mb-3">
													<label for="daysSelect" class="form-label"
														>{{ $t("days") }}:</label
													>
													<v-autocomplete
														v-model="newSlot.days"
														v-bind:items="weekDays"
														item-text="name"
														multiple
														chips
														deletable-chips
													>
													</v-autocomplete>
												</div>
											</div>
										</div>

										<button
											type="button"
											class="btn btn-Primary"
											v-on:click="confirmAddSlot"
										>
											{{ $t("Confirm") }}
										</button>
									</div>
								</div>
							</div>
						</div>
						<div v-if="activeStep === 4" class="step-body step-4">
							<h2 class="step-title">{{ $t("savedData") }}</h2>
							<div class="preview-card mb-2">
								<div class="edit-icon" v-on:click="activeStep = 1">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										fill="currentColor"
										class="bi bi-pencil"
										viewBox="0 0 16 16"
									>
										<path
											d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
										/>
									</svg>
								</div>
								<div class="row">
									<div class="col-md-2">
										<div class="avatar-container">
											<div
												class="avatar-image"
												v-bind:style="
													`background-image: url('${currentAvatar}')`
												"
											></div>
											<input
												type="file"
												id="photoInput"
												hidden
												accept="image/png, image/jpeg"
												v-on:change="changeCurrentAvatar"
											/>
										</div>
									</div>
									<div class="col-md-4">
										<div class="row">
											<div class="col-md-3">
												<p>{{ $t("first_name") }}</p>
												<p>{{ $t("last_name") }}</p>
												<p>{{ $t("Email") }}</p>
												<p>{{ $t("phone_number") }}</p>
												<p>{{ $t("birthdate") }}</p>
											</div>
											<div class="col-md-9">
												<p>: {{ localTutor.first_name }}</p>
												<p>: {{ localTutor.last_name }}</p>
												<p>: {{ localTutor.email }}</p>
												<p>: {{ localTutor.phone_number }}</p>
												<p>: {{ localTutor.date_of_birth }}</p>
											</div>
										</div>
									</div>
									<div class="col-md-6 bio-data">
										<div class="row">
											<div class="col-md-3">
												<p>{{ $t("bio/certificates") }}</p>
											</div>
											<div class="col-md-9">
												<p>{{ localTutor.bio }}</p>
											</div>
										</div>
										<div class="row">
											<div class="col-md-3">
												<p>{{ $t("country") }} :</p>
											</div>
											<div class="col-md-9">
												{{ selectedCountry }}
											</div>
										</div>
										<div class="row">
											<div class="col-md-3">
												<p>{{ $t("language") }} :</p>
											</div>
											<div class="col-md-9">
												<span
													v-for="(lang, index) of choosedLanguages"
													v-bind:key="lang.id"
												>
													{{ lang.details.language }} - {{ lang.details.level }}
													<span v-if="index < choosedLanguages.length - 1">
														/
													</span>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="preview-card">
										<div class="edit-icon" v-on:click="activeStep = 2">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="16"
												height="16"
												fill="currentColor"
												class="bi bi-pencil"
												viewBox="0 0 16 16"
											>
												<path
													d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
												/>
											</svg>
										</div>
										<p>{{ $t("associatedCourses") }}:</p>
										<div class="row">
											<div
												class="col-md-4"
												v-for="(courseType, index) in localTutor.courses"
												:key="index"
											>
												<p>{{ index }}:</p>
												<div v-for="course in courseType" :key="course.id">
													<div
														v-if="
															localTutor.associatedCourses[index].includes(
																course.id
															)
														"
													>
														<p>{{ course.title }}</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="preview-card slots">
										<div class="edit-icon" v-on:click="activeStep = 3">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="16"
												height="16"
												fill="currentColor"
												class="bi bi-pencil"
												viewBox="0 0 16 16"
											>
												<path
													d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
												/>
											</svg>
										</div>
										<p>{{ $t("availableTime") }}:</p>
										<div class="row">
											<div class="col-md-12">
												<calendar
													v-bind:events="events"
													v-on:event-selected="changeCurrentSlot"
													:hoverEffect="false"
												></calendar>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button
							v-if="activeStep > 1"
							type="button"
							class="btn btn-secondary"
							v-on:click="prevStep"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								fill="currentColor"
								class="bi bi-chevron-left"
								viewBox="0 0 16 16"
							>
								<path
									fill-rule="evenodd"
									d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
								/>
							</svg>
							{{$t("Back")}}
						</button>
						<button
            v-else
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            v-on:click="closeTutor"
						>
							<svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-left"
              viewBox="0 0 16 16"
							>
              <path
              fill-rule="evenodd"
              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              />
            </svg>
            {{$t("Back")}}
          </button>
          <button
							type="button"
							class="btn btn-primary"
							v-if="activeStep < 4"
							v-on:click="nextStep"
              >
              {{$t("save&Continue")}}
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								fill="currentColor"
								class="bi bi-chevron-right"
								viewBox="0 0 16 16"
							>
								<path
									fill-rule="evenodd"
									d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
								/>
							</svg>
						</button>
						<button
							type="button"
							class="btn btn-primary"
							v-if="activeStep === 4"
							v-on:click="approveTutor"
						>
							 {{$t("save")}}
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								fill="currentColor"
								class="bi bi-chevron-right"
								viewBox="0 0 16 16"
							>
								<path
									fill-rule="evenodd"
									d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="fileUploadModal" tabindex="-1">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<button
							type="button"
							class="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
						></button>
					</div>
					<div class="modal-body">
						<div class="mb-3 input-container">
							<label for="docFileInput" class="form-label">File</label>
							<input
								type="file"
								class="form-control"
								accept="video/* , audio/*"
								id="docFileInput"
								v-on:change="updateCourseFile"
							/>
						</div>
						<div class="mb-3 input-container">
							<label for="fileNameInput" class="form-label">File Name</label>
							<input
								type="text"
								class="form-control"
								id="fileNameInput"
								v-model="courseFile.name"
							/>
						</div>
						<div class="mb-3 input-container textarea">
							<label for="fileDescriptionInput" class="form-label"
								>File Description</label
							>
							<textarea
								class="form-control"
								id="fileDescriptionInput"
								rows="3"
								v-model="courseFile.description"
							></textarea>
						</div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-secondary"
							data-bs-dismiss="modal"
						>
							Back
						</button>
						<button
							type="button"
							class="btn btn-primary"
							v-on:click="uploadCourseFile"
						>
							Upload
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import moment from "moment";
import Vue from "vue";
import calendar from "@/components/global/calendar.vue";

export default {
	mixins: [GlobalMixin],
	components: { calendar },
	props: {
		tutor: {
			required: false,
			default: () => "",
		},
	},
	data() {
		return {
			currentIns: 1,
			loading: false,
			activeStep: 1,
			localTutor: {
				id: 1,
			},
			currentAvatar: null,
			currentSlot: null,
			currentSlotData: null,
			showAddSlot: false,
			newSlot: {
				start_time: null,
				end_time: null,
				days: [],
				start_date: null,
				end_date: null,
				institute: this.currentIns,
			},
			schedule: [],
			courseFile: {},
			events: [],
			languages: [],
			levels: [],
			currLang: "",
			currLevel: "",
			choosedLanguages: [],
			modal: false,
			endDateModal: false,
			startTimeModal: false,
			endTimeModal: false,
		};
	},
	mounted() {
		let params = new URLSearchParams(window.location.search);
		this.currentIns = params.get("ins") ? params.get("ins") : 1;
		this.localTutor = this.tutor;
		this.allLanguages();
		if (this.localTutor.id) {
			this.getBio();
		}
	},
	methods: {
		/**
		 * Get all language and Levels from tutor/languages/ end point
		 * and assiging them to languages and levels properties
		 */
		allLanguages() {
			this.axios(
				`${process.env.VUE_APP_APIEndPoint}tutor/languages/`,
				this.headers
			).then(res => {
				const {
					data: { languages, language_levels },
				} = res;
				this.languages = languages;
				this.levels = language_levels;
			});
		},
		/**
		 * Handle Adding language to choosedLanguages array
		 * and clear currLang / currLevel properties after adding the language
		 * if they are already added, stop adding the language and clear properties
		 */
		addLanguage() {
			if (!this.currLang || !this.currLevel) return;
			const lang = {
				id: this.choosedLanguages.length + 1,
				details: {
					id: this.languages.find(l => l.name == this.currLang).id,
					language: this.currLang,
					level: this.currLevel,
				},
			};
			if (
				this.choosedLanguages.find(
					l =>
						l.details.language === this.currLang &&
						l.details.level === this.currLevel
				)
			) {
				this.currLang = "";
				this.currLevel = "";
				return;
			}
			this.choosedLanguages.push(lang);
			this.choosedLanguages = this.choosedLanguages.sort((a, b) =>
				a.details.language > b.details.language ? 1 : -1
			);
			this.currLang = "";
			this.currLevel = "";
		},

		/**
		 * Handle Adding language
		 * @param index passing the index of the removed language
		 * using filter to remove the language from choosedLanguages array
		 */
		clearLang(index) {
			this.choosedLanguages = this.choosedLanguages.filter(l => l.id != index);
		},
		closeTutor() {
			$("#tutorEditModal").modal("hide");
			var refresh =
				window.location.protocol +
				"//" +
				window.location.host +
				window.location.pathname +
				window.location.search.split("tutor-id")[0];
			window.history.pushState({ path: refresh }, "", refresh);
		},
		approveTutor() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/status/change/${this.localTutor.id}/`,
					{ status: "approved" },
					this.headers
				)
				.then(res => {
					this.loading = false;
					window.location.href = `/dashboard/approved-tutors?ins=${this.currentIns}`;
				})
				.catch(error => {
					let errors = "";
					error?.response?.data?.errors?.forEach((value, index) => {
						for (error in value) {
							errors += `<li>${value[error]}</li>`;
						}
					});
					Swal.fire({
						icon: "error",
						html:
							errors === ""
								? "We had an issue with processing the data please try agin later"
								: errors,
					});
					this.loading = false;
				});
		},
		changeCurrentSlot(event) {
			this.showAddSlot = false;
			this.currentSlot = event;
		},
		uploadCourseFile() {
			this.loading = true;
			let fd = new FormData();
			fd.append("name", this.courseFile.name);
			fd.append("description", this.courseFile.description);
			fd.append("doc_file ", this.courseFile.doc_file);
			fd.append("institute", this.courseFile.institute);
			fd.append("user", this.courseFile.user);
			fd.append("course", this.courseFile.course);
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/supporting/doc/`,
					fd,
					this.headers
				)
				.then(res => {
					this.loading = false;
					Swal.fire({
						icon: "success",
						text: `Course File added successfully`,
					});
					$("#fileUploadModal").modal("hide");
				})
				.catch(error => {
					let errors = "";
					error?.response?.data?.errors?.forEach((value, index) => {
						for (error in value) {
							errors += `<li>${value[error]}</li>`;
						}
					});
					this.loading = false;
					Swal.fire({
						icon: "error",
						html:
							errors === ""
								? "We had an issue with processing the data please try agin later"
								: errors,
					});
				});
		},
		startCourseFileUpload(courseId) {
			this.courseFile.user = this.localTutor.id;
			this.courseFile.course = courseId;
			this.courseFile.institute = this.currentIns;
			$("#fileUploadModal").modal("show");
		},
		resetNewSlot() {
			this.newSlot = {
				start_time: null,
				end_time: null,
				days: [],
				start_date: null,
				end_date: null,
				institute: this.currentIns,
			};
			$("#startTimeInput").val("");
			$("#endTimeInput").val("");
			$("#daysSelect")
				.val(null)
				.trigger("change");
		},
		confirmAddSlot() {
			this.loading = true;
			this.newSlot.institute = this.currentIns;
			this.newSlot.start_date = moment(this.newSlot.start_date).format(
				"YYYY-MM-DD"
			);
			this.newSlot.end_date = moment(this.newSlot.end_date).format(
				"YYYY-MM-DD"
			);
			this.newSlot.start_time = moment(
				this.newSlot.start_time,
				"hh:mm a"
			).format("HH:mm");
			this.newSlot.end_time = moment(this.newSlot.end_time, "hh:mm a").format(
				"HH:mm"
			);
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/schedule/add/${this.localTutor.id}/`,
					this.newSlot,
					this.headers
				)
				.then(res => {
					Swal.fire({
						icon: "success",
						text: `Slots added successfully`,
					});
					this.getSchedule();
					this.resetNewSlot();
				})
				.catch(error => {
					let errors = "";
					error.response.data.errors.forEach((value, index) => {
						for (error in value) {
							errors += `<li>${value[error]}</li>`;
						}
					});
					this.loading = false;
					Swal.fire({
						icon: "error",
						html:
							errors === ""
								? "We had an issue with processing the data please try agin later"
								: errors,
					});
				});
		},
		determinePartialCheck() {
			for (const course_type_name in this.localTutor.associatedCourses) {
				let mainCheckbox = document.querySelectorAll(
					`.course-checkbox-${course_type_name}`
				);
				if (
					this.localTutor.associatedCourses[course_type_name].length > 0 &&
					this.localTutor.associatedCourses[course_type_name].length <
						this.localTutor.courses[course_type_name].length
				) {
					mainCheckbox.forEach(checkbox => {
						checkbox.indeterminate = true;
					});
				} else if (
					this.localTutor.associatedCourses[course_type_name].length > 0 &&
					this.localTutor.associatedCourses[course_type_name].length ===
						this.localTutor.courses[course_type_name].length
				) {
					mainCheckbox.forEach(checkbox => {
						checkbox.checked = true;
					});
				} else {
					mainCheckbox.forEach(checkbox => {
						checkbox.indeterminate = false;
					});
				}
			}
		},
		toggleSelectAll(index) {
			if (
				this.localTutor.associatedCourses[index].length <
				this.localTutor.courses[index].length
			) {
				this.localTutor.associatedCourses[index] = this.localTutor.courses[
					index
				].map(course => course.id);
			} else {
				this.localTutor.associatedCourses[index] = [];
			}
		},
		toggleCourseAssociate(course) {
			if (
				this.localTutor.associatedCourses[course.course_type_name].includes(
					course.id
				)
			) {
				let deleteIndex = this.localTutor.associatedCourses[
					course.course_type_name
				].indexOf(course.id);
				this.localTutor.associatedCourses[course.course_type_name].splice(
					deleteIndex,
					1
				);
			} else {
				this.localTutor.associatedCourses[course.course_type_name].push(
					course.id
				);
			}
			this.determinePartialCheck();
		},
		cancelAddSlot() {
			this.showAddSlot = false;
			this.newSlot = {
				start_time: null,
				end_time: null,
				days: [],
				start_date: null,
				end_date: null,
				institute: this.currentIns,
			};
		},
		startAddSlot() {
			this.showAddSlot = true;
		},
		deleteSlot() {
			Swal.fire({
				title: `Are you sure you want to delete this slot?`,
				showCancelButton: true,
				confirmButtonText: "Delete",
			}).then(result => {
				if (result.isConfirmed) {
					this.loading = true;
					this.axios
						.post(
							`${process.env.VUE_APP_APIEndPoint}tutor/schedule/delete/${this.localTutor.id}/`,
							{
								start_time: this.currentSlot.start_datetime.format("HH:mm"),
								end_time: this.currentSlot.end_datetime.format("HH:mm"),
								days: [
									this.currentSlot.start_datetime.day() !== 0
										? this.currentSlot.start_datetime.day()
										: 7,
								],
								start_date: this.currentSlot.start_datetime.format(
									"YYYY-MM-DD"
								),
								end_date: this.currentSlot.end_datetime.format("YYYY-MM-DD"),
								institute: this.currentIns,
							},
							this.headers
						)
						.then(res => {
							Swal.fire({
								icon: "success",
								text: `Slot deleted successfully`,
							});
							this.currentSlot = null;
							this.getSchedule();
						})
						.catch(error => {
							let errors = "";
							error.response.data.errors.forEach((value, index) => {
								for (error in value) {
									errors += `<li>${value[error]}</li>`;
								}
							});
							this.loading = false;
							Swal.fire({
								icon: "error",
								html:
									errors === ""
										? "We had an issue with processing the data please try agin later"
										: errors,
							});
						});
				}
			});
		},
		prevStep() {
			this.activeStep--;
		},
		nextStep() {
			if (this.activeStep === 1) {
				this.saveStep1();
				return;
			} else if (this.activeStep === 2) {
				this.saveStep2();
				return;
			} else if (this.activeStep === 4) {
				$("#tutorEditModal").modal("hide");
				this.activeStep === 1;
				return;
			}
			this.activeStep++;
		},

		clearInputFile(f) {
			var form = document.createElement("form"),
				parentNode = f.parentNode,
				ref = f.nextSibling;
			form.appendChild(f);
			form.reset();
			parentNode.insertBefore(f, ref);
		},
		removeFile(course, index) {
			course.files.splice(index, 1);
		},
		uploadPhoto() {
			$("#photoInput").click();
		},
		chooseFile(course) {
			$(`#fileInput${course.id}`).click();
		},
		appendTempFile(course) {
			if (course.tempFile.file) {
				course.files.push(course.tempFile);
				this.clearInputFile($(`#fileInput${course.id}`)[0]);
				course.tempFile = {
					name: "",
					file: null,
				};
			}
		},
		updateCourseFile(e) {
			this.courseFile.doc_file = e.target.files[0];
		},
		changeCurrentAvatar(e) {
			this.localTutor.avatar = e.target.files[0];
			var reader = new FileReader();
			reader.onload = () => {
				this.currentAvatar = reader.result;
			};
			reader.readAsDataURL(e.target.files[0]);
		},
		getBio() {
			this.axios(
				`${process.env.VUE_APP_APIEndPoint}tutor/bio-info/${this.localTutor.id}/`
			).then(res => {
				const {
					data: {
						data: { languages },
					},
				} = res;

				this.choosedLanguages = [];
				languages.forEach(l => {
					const details = this.languages.find(lang => lang.id == l.language);
					this.choosedLanguages.push({
						id: this.choosedLanguages.length + 1,
						details: {
							id: l.language,
							level: l.level,
							language: l.language == details.id ? details.name : "",
						},
					});
				});
			});
		},
		getSchedule() {
			var self = this;
			self.loading = true;
			this.events = [];
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/schedule/list/${this.localTutor.id}/`,
					{},
					this.headers
				)
				.then(res => {
					res.data.data.slots.map(slot => {
						this.events.push({
							id: slot.id,
							name: "",
							start: new Date(slot.start_datetime),
							end: new Date(slot.end_datetime),
							color: "green",
							timed: true,
							start_datetime: moment(slot.start_datetime),
							end_datetime: moment(slot.end_datetime),
						});
					});
					self.loading = false;
				});
		},
		saveStep1() {
			console.log(this.localTutor);
			this.loading = true;
			let fd = new FormData();
			fd.append("first_name", this.localTutor.first_name);
			fd.append("last_name", this.localTutor.last_name);
			fd.append("phone_number", this.localTutor.phone_number);
			fd.append("date_of_birth", this.localTutor.date_of_birth);
			if (
				typeof this.localTutor.avatar === "string" ||
				this.localTutor.avatar instanceof String
			) {
				fd.append("profile_photo_url", this.localTutor.avatar);
			} else {
				fd.append("profile_photo", this.localTutor.avatar);
			}
			fd.append("zip_code", " ");
			fd.append("city", " ");
			fd.append("street_address", " ");
			fd.append("country", this.localTutor.country_id);
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/basic-info/${this.localTutor.id}/`,
					fd,
					this.headers
				)
				.then(res => {
					const languages = this.choosedLanguages.map(l => {
						return {
							language: l.details.id,
							level: l.details.level,
						};
					});

					const data = {
						bio_data: this.localTutor.bio,
						session_fee: parseInt(this.localTutor.session_fee),
						languages,
					};

					this.axios
						.post(
							`${process.env.VUE_APP_APIEndPoint}tutor/bio-info/${this.localTutor.id}/`,
							data,
							this.headers
						)
						.then(res2 => {
							this.loading = false;
							this.activeStep = 2;
						})
						.catch(error => {
							let errors = "";
							error?.response?.data?.errors?.forEach((value, index) => {
								for (error in value) {
									errors += `<li>${value[error]}</li>`;
								}
							});
							Swal.fire({
								icon: "error",
								html:
									errors === ""
										? "We had an issue with processing the data please try agin later"
										: errors,
							});
							this.loading = false;
						});
				})
				.catch(error => {
					let errors = "";
					error?.response?.data?.errors?.forEach((value, index) => {
						for (error in value) {
							errors += `<li>${value[error]}</li>`;
						}
					});
					Swal.fire({
						icon: "error",
						html:
							errors === ""
								? "We had an issue with processing the data please try agin later"
								: errors,
					});
					this.loading = false;
				});
		},
		getAssociatedCourses() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/associated/`,
					{
						tutor: this.localTutor.id,
						institute: this.currentIns,
					},
					this.headers
				)
				.then(res => {
					res.data.data.forEach(course => {
						if (
							!this.localTutor.associatedCourses[
								this.localTutor.courseTypes[course.course_type_id]
							].includes(course.course_id)
						) {
							this.localTutor.associatedCourses[
								this.localTutor.courseTypes[course.course_type_id]
							].push(course.course_id);
						}
					});
					this.determinePartialCheck();
				});
		},
		saveStep2() {
			this.loading = true;
			let courses = [];
			Object.values(this.localTutor.courseTypes).forEach(courseTypeName => {
				courses = courses.concat(
					this.localTutor.associatedCourses[courseTypeName[0]]
				);
			});
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/associate_course/`,
					{
						tutor: this.localTutor.id,
						courses,
						institute: this.currentIns,
						remove_others_courses: true,
					},
					this.headers
				)
				.then(res => {
					this.loading = false;
					this.activeStep = 3;
				})
				.catch(error => {
					let errors = "";
					error?.response?.data?.errors?.forEach((value, index) => {
						for (error in value) {
							errors += `<li>${value[error]}</li>`;
						}
					});
					Swal.fire({
						icon: "error",
						html:
							errors === ""
								? "We had an issue with processing the data please try agin later"
								: errors,
					});
					this.loading = false;
				});
		},
	},
	computed: {
		selectedCountry() {
			return this.countries.find(c => this.localTutor.country_id == c.id).name;
		},
	},
	watch: {
		tutor: {
			handler() {
				this.localTutor = this.tutor;
				this.localTutor.country = this.countries.find(
					c => this.localTutor.country_id == c.id
				)?.name;
				this.currentAvatar = this.localTutor?.avatar
					? this.localTutor.avatar
					: this.localTutor.gender === "Male"
					? "/assets/images/tutors/02.png"
					: "/assets/images/tutors/01.png";
				if (this.localTutor.id) {
					this.getBio();
				}
				this.activeStep = 1;
				this.currentSlot = null;
				this.currentSlotData = null;
				this.showAddSlot = false;
			},
			deep: true,
		},
		activeStep: {
			handler() {
				if (this.activeStep === 2) {
					Vue.nextTick(() => {
						this.getAssociatedCourses();
						this.determinePartialCheck();
					});
				} else if (this.activeStep === 3) {
					this.getSchedule();
					//               created_on
					// :
					// "2022-10-27 10:44:16"
					// end_datetime
					// :
					// "2022-10-27 13:00:00"
					// id
					// :
					// 11763
					// institute
					// :
					// 1
					// is_active
					// :
					// true
					// start_datetime
					// :
					// "2022-10-27 12:00:00"
					// tutor
					// :
					// 469
					// updated_on
					// :
					// "2022-10-27 10:44:16"
				}
			},
		},
		"newSlot.start_date": {
			handler(newVal, oldVal) {
				this.newSlot.end_date = "";
			},
		},
		"newSlot.start_time": {
			handler(newVal, oldVal) {
				this.newSlot.end_time = "";
			},
		},
	},
};
</script>
<style scoped lang="scss">
.modal-dialog {
	min-width: 90%;

	.modal-header {
		justify-content: center;
		border-bottom: none;

		.btn-close {
			position: absolute;
			right: 10px;
		}

		.wizard-steps-container {
			display: flex;

			.step {
				padding: 5px 12px;
				border-radius: 50%;
				margin: 5px;
				width: 30px;
				height: 30px;
				color: white;
				font-weight: bold;
				background-color: lightgray;

				&.active {
					background-color: var(--auth-second-color);
				}

				&.passed {
					background-color: #5fae32;
				}
			}

			.seperator {
				width: 60px;
				height: 2px;
				background-color: lightgray;
				margin: auto;

				&.active {
					background-color: var(--auth-second-color);
				}
			}
		}
	}

	.modal-body {
		.step-body {
			text-align: center;

			.btn-secondary {
				background-color: white;
				border: 2px solid var(--auth-second-color);
				color: var(--auth-second-color) !important;
				padding: 5px 10px;
				border-radius: 20px;
			}

			.step-title {
				color: var(--auth-second-color);
				font-size: 23px;
				font-weight: normal;
				display: block;
				clear: both;
			}

			.avatar-container {
				margin: auto;
				display: flex;
				justify-content: center;
				position: relative;

				.avatar-image {
					width: 100px;
					height: 100px;
					border-radius: 50px;
					background-position: center;
					background-size: cover;
				}

				.upload-btn {
					position: absolute;
					bottom: -20px;
				}
			}

			.data-container {
				margin: 20px;

				.input-container {
					display: flex;

					.form-label {
						color: #9f9f9f;
						margin: auto;
					}

					.form-control {
						height: 35px;
						border-radius: 20px;
						width: 75%;
						margin-left: 3%;
					}

					&.textarea {
						height: 100%;

						.form-label {
							margin-top: 0;
							margin-bottom: 0;
						}

						.form-control {
							height: 100%;
						}
					}
				}
			}

			.course-container {
				display: flex;
				flex-direction: column;

				&:not(:last-child) {
					border-right: 1px solid lightgray;
				}

				* {
					text-align: start;
				}

				.form-check {
					padding-left: 0;

					.form-check-input {
						margin: 2px 0 !important;
					}
				}

				.form-check-input:checked {
					background-color: var(--auth-second-color);
					border-color: var(--auth-second-color);
				}

				.form-check-input:checked + .form-check-label {
					color: var(--auth-second-color);
				}

				.input-container {
					display: flex;
					justify-content: flex-start;

					.form-label {
						margin: auto 10px auto 0;
					}

					.form-control {
						width: 100%;
						text-align: center;
						color: #9f9f9f;
					}

					.input-group {
						position: relative;
						max-width: 150px;

						.input-group-text {
							height: 35px;
							border-radius: 20px;
							position: absolute;
							left: 0;
							z-index: 6;
							padding: 0.375rem 1.5rem;
							background-color: white;
							color: var(--auth-second-color);
							border-color: var(--auth-second-color);
							font-weight: bold;
						}

						.form-control {
							border-radius: 20px;
							padding-left: 4rem;
						}
					}

					&.file-input {
						.input-group {
							cursor: pointer;
							max-width: 100%;

							.form-control {
								padding-left: 8rem;
							}
						}
					}
				}

				.files-container {
					margin-top: 10px;

					.single-file {
						display: flex;
						justify-content: space-between;
						margin: 10px 0;

						span {
							color: #9f9f9f;
						}

						svg {
							cursor: pointer;
							fill: #ff7e7e;
						}
					}
				}

				.disabled {
					pointer-events: none;
					opacity: 0.5;
				}
			}

			.current-slot-card {
				background-color: #f8f8f8;
				border-radius: 8px;
				padding: 20px;
				position: relative;

				h3 {
					color: #707070;
					font-size: x-large;
				}

				.input-group-text {
					position: absolute;
					right: 0;
					background-color: white;
					color: #0180d8;
					border-color: #0180d8;
					border-radius: 25px;
					z-index: 2;
					height: 100%;
				}

				.delete-icon {
					position: absolute;
					top: 10px;
					right: 10px;
					background-color: #ff5d5d;
					color: #f8f8f8;
					padding: 3px 5px;
					border-radius: 50%;
					cursor: pointer;
				}
			}

			.preview-card {
				position: relative;
				background-color: #f8f8f8;
				padding: 20px;
				border-radius: 5px;
				text-align: start;
				max-height: 200px;
				overflow-y: auto;

				div,
				.row,
				.row div {
					text-align: start;
					word-break: break-word;
				}

				p {
					color: #707070;
					font-size: small;
					margin-bottom: 5px;
				}

				.edit-icon {
					position: absolute;
					top: 5px;
					right: 5px;
					color: #0180d8;
					border: #0180d8 1px solid;
					background-color: white;
					border-radius: 50%;
					padding: 3px 5px;
					cursor: pointer;
				}

				.files-container {
					p {
						width: calc(100% - 15px);
						display: inline-block;
					}

					svg {
						position: relative;
						top: 50%;
						transform: translateY(-100%);
					}
				}
			}
		}
	}

	.modal-footer {
		border-top: none;
		display: flex;
		justify-content: space-evenly;
	}
}

button {
	background-color: var(--auth-second-color);
	color: white;
	padding: 5px 10px;
	border-radius: 20px;
	text-align: center !important;

	&[disabled] {
		background-color: lightgray;
	}
}

#daysSelect {
	width: calc(100% - 34px);
}

.step-2 {
	.courses-container {
		max-height: 200px;
		overflow-y: auto;

		.file-upload-icon-button {
			cursor: pointer;
			color: var(--auth-second-color);
			display: inline-block;
			margin: 0 5px;
		}
	}
}

.step-3 {
	.days-container {
		height: calc(100vh - 260px);

		.accordion-item {
			.accordion-button {
				border-radius: 0;
				margin-bottom: 5px;

				&:after {
					background-color: white;
					border-radius: 50%;
					padding: 12px;
					background-position: center;
				}
			}

			.accordion-body {
				display: flex;

				.slot-card {
					display: flex;
					border: 1px solid var(--auth-second-color);
					background-color: var(--auth-second-color);
					color: white;
					transition: all 0.2s ease-in-out;
					border-radius: 20px;
					cursor: pointer;
					padding: 3px 5px;
					margin: 5px;

					&:hover {
						color: var(--auth-second-color);
						background-color: white;
					}

					svg {
						margin: auto;
					}
				}
			}
		}
	}
}

.loader {
	position: fixed;
	top: 0;
	z-index: 999999;
	left: 0;
	height: 100vh;
	width: 100vw;

	.background {
		background: #2196f39e;
		color: #fff;
		display: flex;
		height: 100vh;
		width: 100vw;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		#text {
			display: flex;

			p {
				color: #fff !important;
				margin: auto;
			}
		}
	}

	#coffee,
	#text {
		flex: 1 1 auto;
	}

	#text {
		font-size: 4em;
		font-family: fantasy;
		text-align: center;
	}

	#text p {
		padding: 0;
		margin: 0;
	}

	#text p.h1 {
		font-size: 1.8em;
	}

	#text p.h2 {
		font-size: 1.2em;
	}

	#Layer_1 {
		height: 40vh;
		transform: translateY(25vh);
		opacity: 0;
		-webkit-animation: vew-set 10s ease-in-out forwards;
		animation: vew-set 10s ease-in-out forwards;
	}

	#Layer_1 #teaBag {
		transform: translateX(-240px) translateY(80px);
		-webkit-animation: bag-set 5s ease-in-out forwards;
		animation: bag-set 5s ease-in-out forwards;
	}

	#Layer_1 #teaBag #bar {
		-webkit-animation: diping 2s ease-in-out 4.5s infinite;
		animation: diping 2s ease-in-out 4.5s infinite;
	}

	#Layer_1 #smoke {
		opacity: 0;
		transform: translateY(10px);
		-webkit-animation: smoking 2s ease-in-out 8.2s infinite;
		animation: smoking 2s ease-in-out 8.2s infinite;
	}

	@-webkit-keyframes vew-set {
		5%,
		100% {
			opacity: 1;
		}

		89% {
			transform: translateY(25vh);
		}

		95%,
		100% {
			transform: translateY(0);
		}
	}

	@keyframes vew-set {
		5%,
		100% {
			opacity: 1;
		}

		89% {
			transform: translateY(25vh);
		}

		95%,
		100% {
			transform: translateY(0);
		}
	}

	@-webkit-keyframes diping {
		50% {
			transform: translateY(50px);
		}
	}

	@keyframes diping {
		50% {
			transform: translateY(50px);
		}
	}

	@-webkit-keyframes smoking {
		20% {
			opacity: 1;
		}

		80% {
			opacity: 0;
			transform: translateY(-40px);
		}
	}

	@keyframes smoking {
		20% {
			opacity: 1;
		}

		80% {
			opacity: 0;
			transform: translateY(-40px);
		}
	}

	@-webkit-keyframes bag-set {
		33% {
			transform: translateX(-180px) translateY(-150px);
		}

		66% {
			transform: translateX(-20px) translateY(-150px);
		}

		100% {
			transform: translateX(0) translateY(0px);
		}
	}

	@keyframes bag-set {
		33% {
			transform: translateX(-180px) translateY(-150px);
		}

		66% {
			transform: translateX(-20px) translateY(-150px);
		}

		100% {
			transform: translateX(0) translateY(0px);
		}
	}

	@-webkit-keyframes vew-tex {
		100% {
			visibility: visible;
			opacity: 1;
			transform: translateY(0px);
		}
	}

	@keyframes vew-tex {
		100% {
			visibility: visible;
			opacity: 1;
			transform: translateY(0px);
		}
	}

	.st0 {
		fill: #dbdbdb;
	}

	.st1 {
		fill: #29282a;
	}

	.st2 {
		fill: #ffffff;
	}

	.st3 {
		fill: #4b392a;
	}

	.st4 {
		fill: #bbdefb;
	}

	.st5 {
		fill: #0d47a1;
	}

	.st6 {
		fill: #1565c0;
	}

	.st7 {
		fill-rule: evenodd;
		clip-rule: evenodd;
		fill: #01579b;
	}

	.st8 {
		fill-rule: evenodd;
		clip-rule: evenodd;
		fill: #90caf9;
	}

	.st9 {
		fill-rule: evenodd;
		clip-rule: evenodd;
		fill: #d7ccc8;
	}
}
</style>
